"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIModelDeployableStatuses = exports.VertexAIModelSourceType = void 0;
const ai_registry_1 = require("./ai-registry");
var VertexAIModelSourceType;
(function (VertexAIModelSourceType) {
    VertexAIModelSourceType["ModelGarden"] = "Model Garden";
    VertexAIModelSourceType["ModelRegistry"] = "Model Registry";
})(VertexAIModelSourceType || (exports.VertexAIModelSourceType = VertexAIModelSourceType = {}));
exports.AIModelDeployableStatuses = [
    ai_registry_1.DeploymentStatus.Undeployed,
    ai_registry_1.DeploymentStatus.ErrorDeploy,
];
